import { ValidateEmail } from '@swivl-mono/helpers';
import { Button, ButtonColor, ButtonSize, Input } from '@swivl-mono/ui';
import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import AccountModel from '../../../Models/Account/AccountModel';
import { AlertsModel } from '../../../Models/Notifications/Alerts.Model';
import Logo from '../Assets/SwivlLogo.png';

export function ForgotPasswordView() {
  const navigate = useNavigate();
  const [queryParams, setQueryParams] = useSearchParams();
  const [username, setUsername] = useState(queryParams?.get("email") ?? "chuck@tryswivl.com");
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const recoverAccount = () => {
    const validEmail = ValidateEmail(username.toLowerCase());
    if (validEmail === false) {
      setIsLoading(true);
      setErrorMsg("Please enter a valid email");
      return;
    }
    setIsLoading(true);
    setErrorMsg("");
    try {
      AccountModel.forgotPassword(username).then((response) => {
        setIsLoading(false);
        AlertsModel.successToast("Instructions to reset your password have been sent to your email address");
        navigate("/login?email=" + username);
      })
    } catch (error) {
      setIsLoading(false);
      setErrorMsg("An error occurred while processing your request. Please try again later.");
    }
  }

  return (<div className="ForgotPasswordView flex flex-col items-center">
    <img src={Logo} alt="Swivl Logo" className="w-1/2 mx-auto mb-8" />
    <div className="container mx-auto">

      <div className="loginContent">
        <div className="forgotParagraph">Enter the email address associated with your swivl Studio account and we'll send you instructions on how to reset your password.</div>
        <h4>Email Address</h4>
        <Input
          size={Input.Size.Large}
          value={username}
          name="username"
          onSet={setUsername}
          enableAutoComplete={true}
        />

        <Button
          className="mb-5"
          onClick={recoverAccount}
          loading={isLoading}
          color={ButtonColor.ORANGE}
          size={ButtonSize.LARGE}
        >
          SUBMIT
        </Button>

        <Link className="backToLogin" to="/login">Back</Link>
      </div>
    </div>
    <div className="errorMsg">{errorMsg}</div>
  </div>
  );
}